export const API_comment_point = (_id: string): string => `/api/v1/comments/points/${_id}`;
export const API_comment = (commentId: string): string => `/api/v1/comments/${commentId}`;
